import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow-md p-6" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center items-center py-12"
}
const _hoisted_3 = {
  key: 1,
  class: "bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative mb-6"
}
const _hoisted_4 = { class: "block sm:inline" }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "mb-6 border-b border-gray-200 pb-6" }
const _hoisted_7 = { class: "flex justify-between items-center mb-4" }
const _hoisted_8 = {
  key: 0,
  class: "mb-4 p-4 border border-primary/20 rounded-lg bg-primary/5"
}
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "flex justify-end space-x-2" }
const _hoisted_12 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = { class: "font-medium" }
const _hoisted_16 = { class: "text-sm text-gray-500" }
const _hoisted_17 = { class: "mb-6" }
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = { class: "mb-4" }
const _hoisted_20 = { class: "mb-4" }
const _hoisted_21 = { class: "border border-gray-300 rounded-t-md bg-gray-50 p-2 flex flex-wrap gap-1" }
const _hoisted_22 = { class: "mb-4" }
const _hoisted_23 = { class: "flex justify-between items-center mb-2" }
const _hoisted_24 = { class: "flex flex-wrap gap-2" }
const _hoisted_25 = ["onClick", "title"]
const _hoisted_26 = { class: "flex justify-end space-x-3" }
const _hoisted_27 = { class: "mt-8" }
const _hoisted_28 = { class: "border border-gray-300 rounded-md p-4 bg-gray-50" }
const _hoisted_29 = { class: "mb-2" }
const _hoisted_30 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VariableManagerModal = _resolveComponent("VariableManagerModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[16] || (_cache[16] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary" }, null, -1)
        ])))
      : (_ctx.loadingError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[17] || (_cache[17] = _createElementVNode("strong", { class: "font-bold" }, "Error:", -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.loadingError), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "text-lg font-medium" }, "Template Categories", -1)),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showNewCategoryForm = true)),
                  class: "px-3 py-1 border border-primary rounded-md shadow-sm text-sm font-medium text-primary bg-white hover:bg-primary/5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                }, " Add New Category ")
              ]),
              (_ctx.showNewCategoryForm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[21] || (_cache[21] = _createElementVNode("h4", { class: "font-medium mb-2" }, "Create New Template Category", -1)),
                    _createElementVNode("div", _hoisted_9, [
                      _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Category Name", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newCategory.name) = $event)),
                        class: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary",
                        placeholder: "Enter category name"
                      }, null, 512), [
                        [_vModelText, _ctx.newCategory.name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Description", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newCategory.description) = $event)),
                        class: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary",
                        placeholder: "Enter category description"
                      }, null, 512), [
                        [_vModelText, _ctx.newCategory.description]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showNewCategoryForm = false)),
                        class: "px-3 py-1 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                      }, " Cancel "),
                      _createElementVNode("button", {
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addNewCategory && _ctx.addNewCategory(...args))),
                        class: "px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                      }, " Add Category ")
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateCategories, (category) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: category.id,
                    onClick: ($event: any) => (_ctx.selectTemplateCategory(category)),
                    class: _normalizeClass(["border rounded-lg p-4 cursor-pointer transition-all duration-200 hover:shadow-md", [_ctx.selectedCategory === category.id ? 'border-primary bg-primary/5' : 'border-gray-200']])
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center mr-3" }, [
                        _createElementVNode("svg", {
                          class: "h-5 w-5 text-primary",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                          })
                        ])
                      ], -1)),
                      _createElementVNode("div", null, [
                        _createElementVNode("h4", _hoisted_15, _toDisplayString(category.name), 1),
                        _createElementVNode("p", _hoisted_16, _toDisplayString(category.description), 1)
                      ])
                    ])
                  ], 10, _hoisted_13))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[32] || (_cache[32] = _createElementVNode("h3", { class: "text-lg font-medium mb-2" }, "Template Editor", -1)),
              _createElementVNode("div", _hoisted_18, [
                _cache[23] || (_cache[23] = _createElementVNode("label", {
                  for: "template-name",
                  class: "block text-sm font-medium text-gray-700 mb-1"
                }, "Template Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "template-name",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.templateName) = $event)),
                  class: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary",
                  placeholder: "Enter template name"
                }, null, 512), [
                  [_vModelText, _ctx.templateName]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[24] || (_cache[24] = _createElementVNode("label", {
                  for: "template-subject",
                  class: "block text-sm font-medium text-gray-700 mb-1"
                }, "Email Subject", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "template-subject",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.emailSubject) = $event)),
                  class: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary",
                  placeholder: "Enter email subject"
                }, null, 512), [
                  [_vModelText, _ctx.emailSubject]
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[30] || (_cache[30] = _createElementVNode("label", {
                  for: "template-content",
                  class: "block text-sm font-medium text-gray-700 mb-1"
                }, "Email Content", -1)),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.applyFormatting('bold')), ["prevent"])),
                    class: "p-1 rounded hover:bg-gray-200 w-7 h-7 flex items-center justify-center",
                    title: "Bold"
                  }, _cache[25] || (_cache[25] = [
                    _createElementVNode("span", { class: "font-bold text-lg" }, "B", -1)
                  ])),
                  _createElementVNode("button", {
                    onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.applyFormatting('italic')), ["prevent"])),
                    class: "p-1 rounded hover:bg-gray-200 w-7 h-7 flex items-center justify-center",
                    title: "Italic"
                  }, _cache[26] || (_cache[26] = [
                    _createElementVNode("span", { class: "italic text-lg" }, "i", -1)
                  ])),
                  _createElementVNode("button", {
                    onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.applyFormatting('underline')), ["prevent"])),
                    class: "p-1 rounded hover:bg-gray-200 w-7 h-7 flex items-center justify-center",
                    title: "Underline"
                  }, _cache[27] || (_cache[27] = [
                    _createElementVNode("span", { class: "underline text-lg" }, "U", -1)
                  ])),
                  _cache[29] || (_cache[29] = _createElementVNode("span", { class: "w-px h-6 bg-gray-300 mx-1" }, null, -1)),
                  _createElementVNode("button", {
                    onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.applyFormatting('image')), ["prevent"])),
                    class: "p-1 rounded hover:bg-gray-200",
                    title: "Insert Image"
                  }, _cache[28] || (_cache[28] = [
                    _createElementVNode("svg", {
                      class: "h-5 w-5",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                      })
                    ], -1)
                  ]))
                ]),
                _createElementVNode("div", {
                  id: "template-content",
                  contenteditable: "true",
                  onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.updateEmailContent && _ctx.updateEmailContent(...args))),
                  class: "w-full min-h-[250px] px-3 py-2 border border-t-0 border-gray-300 rounded-b-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary",
                  placeholder: "Enter email content. Use {{variable}} for dynamic content."
                }, null, 32)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _cache[31] || (_cache[31] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "Available Variables", -1)),
                  _createElementVNode("button", {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showVariableManager = true)),
                    class: "text-sm text-primary hover:text-primary-dark"
                  }, " Manage Variables ")
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateVariables, (variable) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: variable.name,
                      class: "px-2 py-1 bg-gray-100 text-gray-800 rounded-md text-sm cursor-pointer hover:bg-gray-200",
                      onClick: ($event: any) => (_ctx.insertVariable(variable.name)),
                      title: variable.description
                    }, _toDisplayString(variable.name), 9, _hoisted_25))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("button", {
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args))),
                  class: "px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                }, " Reset "),
                _createElementVNode("button", {
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.updateTemplateCategory && _ctx.updateTemplateCategory(...args))),
                  class: "px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                }, " Update Template ")
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[34] || (_cache[34] = _createElementVNode("h3", { class: "text-lg font-medium mb-2" }, "Template Preview", -1)),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _cache[33] || (_cache[33] = _createElementVNode("strong", null, "Subject:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.emailSubject), 1)
                ]),
                _createElementVNode("div", {
                  class: "prose max-w-none",
                  innerHTML: _ctx.formattedEmailContent
                }, null, 8, _hoisted_30)
              ])
            ])
          ])),
    _createVNode(_component_VariableManagerModal, {
      "is-open": _ctx.showVariableManager,
      variables: _ctx.templateVariables,
      onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showVariableManager = false)),
      "onUpdate:variables": _ctx.updateTemplateVariables
    }, null, 8, ["is-open", "variables", "onUpdate:variables"])
  ]))
}